import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app-environment';
import { Observable } from 'rxjs';

export interface PlatformNotificationEvent {
  notification_data: string;
  event_id: string;
  filter_condition?: string | null;
  file?: {
    file_name?: string;
    file_type?: string;
    file_data?: string;
  };
}

export interface PlatformNotificationResponse {
  events?: PlatformNotificationEvent[];
}

@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  constructor(private readonly http: HttpClient) {}

  getNotifications(email: string): Observable<PlatformNotificationResponse> {
    const baseUrl = String(environment.URL || '').replace(/\/+$/, '');
    return this.http.get<PlatformNotificationResponse>(
      `${baseUrl}/spriced/platform/notification/${encodeURIComponent(email.trim())}`,
    );
  }
}
